import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import store from './state/store';
import { Provider } from 'react-redux';
import ErrorBoundary from './screens/ErrorBoundary';

let ervAppRootId: string = 'root';
if (typeof ervAppRuntime === 'object') {
  if (
    typeof ervAppRuntime.getRuntimeConfig === 'function' &&
    typeof ervAppRuntime.getRuntimeConfig().ervAppRootId === 'string'
  )
    ervAppRootId = ervAppRuntime.getRuntimeConfig().ervAppRootId!;
}

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary key={0}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ErrorBoundary>
  </Provider>,
  document.getElementById(ervAppRootId),
);
